import React, { useCallback, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import { BiData } from '@wix/da-bi/pkg/events';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { pushAdoptsSellerModal } from '../../../Modals/redux/actionCreators';
import { getIsAdoptableFixedPriceType, getIsAdoptableOfferType, getPrice } from '../../../utils/adoptables';
import { ElementVisibilityContext } from '../../ElementVisibilityContext';
import { useEndSaleAction } from '../../../Sidebar/SidebarBlock/layouts/exclusives/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './AdoptableSeller.scss';
export const AdoptableSeller = ({ deviation, className })=>{
    const { elementGroups: { adoptableSeller: adoptableSellerElementVisibility } } = useContext(ElementVisibilityContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const [endSaleAction, endSaleBiData] = useEndSaleAction(deviation, {
        sectionname: 'action_bar'
    });
    const openOfferModal = useCallback(()=>{
        dispatch(pushAdoptsSellerModal(deviation, 'offers'));
    }, [
        deviation,
        dispatch
    ]);
    if (isMobile) {
        return null;
    }
    const isOfferType = getIsAdoptableOfferType(deviation);
    const isFixedPriceType = getIsAdoptableFixedPriceType(deviation);
    const price = getPrice(deviation);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className,
        popoverWrapperClassName: s['wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['status']
    }, isOfferType && !isFixedPriceType && /*#__PURE__*/ React.createElement("span", null, t('actionbar.adoptables.openToOffers')), !isOfferType && isFixedPriceType && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    })), isOfferType && isFixedPriceType && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['subscript']
    }, t('actionbar.adoptables.subtitle')))), /*#__PURE__*/ React.createElement("div", {
        className: s['buttons']
    }, adoptableSellerElementVisibility.endSale && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: endSaleAction,
        className: s['button'],
        biData: endSaleBiData
    }, t('actionbar.adoptables.endSale')), adoptableSellerElementVisibility.viewOffers && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openOfferModal,
        className: s['button'],
        biData: BiData({
            evid: 746,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'action_bar'
        })
    }, t('actionbar.adoptables.viewOffers'))));
};
AdoptableSeller.displayName = 'AdoptableSeller';
export default AdoptableSeller;
